import React from 'react';
import { makeStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Box } from '@mui/material';

const useStyles = makeStyles({
  table: {
    overflowY: 'auto',
    maxHeight: 350,
  },
});

export default function ParamTable({ rows, requiredMode }) {
  const classes = useStyles();
  return (
    <TableContainer
      component={Box}
      className={classes.table}
    >
      <Table aria-label="param table">
        <TableHead>
          <TableRow>
            <TableCell>{requiredMode ? 'Required?' : 'Name'}</TableCell>
            {rows && rows[0] && rows[0].type && <TableCell align="left">Type</TableCell>}
            {rows && rows[0] && rows[0].default && <TableCell align="left">Default</TableCell>}
            {rows && rows[0] && rows[0].description && <TableCell align="left">Description</TableCell>}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows &&
            rows.map((row, index) => (
              <TableRow key={index}>
                <TableCell
                  component="th"
                  scope="row"
                >
                  {row.name}
                </TableCell>
                {row.type && <TableCell align="left">{row.type}</TableCell>}
                {row.default && <TableCell align="left">{row.default}</TableCell>}
                {row.description && <TableCell align="left">{row.description}</TableCell>}
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
